exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".display-block {\n  display: inline; }\n\n.signOut {\n  font-size: 19px !important;\n  margin-left: 4px !important;\n  width: 0.9em !important; }\n", ""]);

// exports


/*** EXPORTS FROM exports-loader ***/
module.exports = module.exports.toString();


//////////////////
// WEBPACK FOOTER
// C:/Projects/Isagenix/GitHub/Mobile.IsaLifeAzure/apps/qualia-platform-admin-web/src/app/layout/sidebar/sidebar.component.scss
// module id = ../../../../../src/app/layout/sidebar/sidebar.component.scss
// module chunks = main